import { useState } from "react";
import { faqs } from "@/mocks/comicGuide";

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <div className="flex flex-col items-center text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-4 py-1.5 text-xs text-secondary-900">
            <i className="ri-question-line text-sm"></i>
            常见问题
          </span>
          <h2 className="mt-4 font-heading text-3xl md:text-4xl text-foreground-900">
            关于怎么读，你问我答
          </h2>
          <p className="mt-3 max-w-2xl text-sm md:text-base text-foreground-600">
            下拉、翻页、目录、全屏这些阅读方式的使用疑问，这里都有答案。
          </p>
        </div>

        <div className="mt-10 space-y-3">
          {faqs.map((faq, i) => {
            const isOpen = openIndex === i;
            return (
              <div
                key={faq.question}
                className={`rounded-lg border bg-background-50 transition-colors ${
                  isOpen ? "border-primary-300" : "border-background-200"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? null : i)}
                  className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left"
                  aria-expanded={isOpen}
                >
                  <span className="flex items-center gap-3 text-base font-semibold text-foreground-900">
                    <i
                      className={`${isOpen ? "ri-question-mark" : "ri-question-line"} ${isOpen ? "text-primary-500" : "text-secondary-500"}`}
                    ></i>
                    {faq.question}
                  </span>
                  <i
                    className={`ri-arrow-down-s-line text-xl text-foreground-500 transition-transform ${isOpen ? "rotate-180" : ""}`}
                  ></i>
                </button>
                {isOpen && (
                  <div className="border-t border-background-200 px-5 py-4">
                    <p className="pl-8 text-sm leading-relaxed text-foreground-600">{faq.answer}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}